import {useQueries} from "@tanstack/react-query";
import natureService from "../../../../services/web/nature-service.js";
import OccurrenceDashboardService from "../../../../services/reports/occurrence-dashboard-service.js";

const UseFetchOptions = () => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['reasons'],
                queryFn: () => natureService.getOccurrencesDetailsNatures().then(data => [{ label: "Não informado", value: "WITHOUT-NATURE" }, ...data]),
                initialData: []
            },
            {
                queryKey: ['city-fact'],
                queryFn: () => OccurrenceDashboardService.cityFact(),
                initialData: [],
            },
        ]
    });

    return {
        reasonOptions: queries[0].data,
        cityFactOptions: queries[1].data,
    }
}

export default UseFetchOptions;